import { useState } from "react"
import { useStateWithGetter } from "./useStateWithGetter"
// import { useAsyncError } from "./useAsyncEffect"

export type IAsyncCallback<Args extends any[]> = {
  (...args: Args): Promise<void>
  calling: boolean
  running: boolean
  error: { message: string; raw: unknown } | null
}

export function useAsyncCallback<Args extends any[]>(
  callback: (...args: Args) => Promise<void>,
  opts?: { runningTimeoutMs?: number; willHandleErrors?: boolean },
): IAsyncCallback<Args> {
  const [runningArgs, setRunningArgs] = useState<Args | null>(null)
  const [_, setCalling, getCalling] = useStateWithGetter(false)
  const [error, setError] = useState<{ message: string; raw: unknown } | null>(null)
  // const throwError = useAsyncError()

  async function wrapped(...args: Args) {
    if (getCalling()) {
      return
    }
    setCalling(true)

    let timeout: any
    try {
      if (opts?.runningTimeoutMs) {
        timeout = setTimeout(() => setRunningArgs(args), opts.runningTimeoutMs)
      } else {
        setRunningArgs(args)
      }
      await callback(...args)
    } catch (error) {
      console.error("Error in async callback")
      console.error(error)
      if (opts?.willHandleErrors) {
        setError(error)
      } else {
        // TODO: enable throwing errors after we've done a look through the code
        // throwError(error)
      }
    } finally {
      clearTimeout(timeout)
      setRunningArgs(null)
      setCalling(false)
    }
  }

  wrapped.running = runningArgs !== null
  wrapped.runningArgs = runningArgs
  wrapped.calling = getCalling()
  wrapped.error = error
  return wrapped
}
